/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home2.css";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="purple"> ABOUT </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m an enthusiastic software developer on a continuous journey of
              learning <br /> and growth. My passion lies in crafting clean,
              user-friendly interfaces and
              <br /> building robust server-side logic. I specialise in web
              development, cloud
              <br /> technologies, and DevOps practices. My goal is to
              collaborate on exciting
              <br /> projects, apply these principles, and achieve excellence
              together. Let's
              <br /> create something amazing!
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <div className="your-component">
              <div className="scene">
                <div className="floor"></div>
                <div className="cube">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
